import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
moment.locale('pt-BR');

@Pipe({
    name: 'pipeHora'
})
export class PipeHora implements PipeTransform {
    transform(date: string): string {
        return moment(date).format('HH:mm')
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeHora.ts